import { CautionIcon, CheckAllIcon, DottedCircleIcon, RestrictedIcon } from '@hypothesis/frontend-shared';
/**
 * Map of moderation statuses to their corresponding human-friendly label and
 * icon
 */
export var moderationStatusInfo = {
  PENDING: {
    label: 'Pending',
    icon: DottedCircleIcon
  },
  APPROVED: {
    label: 'Approved',
    icon: CheckAllIcon
  },
  DENIED: {
    label: 'Declined',
    icon: RestrictedIcon
  },
  SPAM: {
    label: 'Spam',
    icon: CautionIcon
  }
};
Object.freeze(moderationStatusInfo);
var moderationStatuses = Object.keys(moderationStatusInfo);

/**
 * Whether provided status is a moderation status or not
 */
export var isModerationStatus = function isModerationStatus(status) {
  return moderationStatuses.includes(status);
};
//# sourceMappingURL=moderation-status.js.map